import { uid } from 'uid';
import { ModalDialog } from '/modules/vecdoor/uitools';

import { View } from 'ol';
import {CheckBoxItemFactory, CheckBoxItem, CheckBoxDiffImageLayer, 
    CheckBoxItemElevationImageLayer, CheckBoxItemRadarImageLayer, 
    CheckBoxItemShaderImageLayer, CheckBoxItemGeoJsonLayer, CheckBoxItemBingMaps } from './CheckBoxItemLayers';



class Sample {
    constructor(params) {
        this.name = params.name;
        this.description = params.description;
        this.panes = [];
        if (params.panes !== undefined) {
            params.panes.forEach(pane => {
                this.addPane(new LayersPane(pane));
            }
            );
        }
        this.mapInfo = (params.mapInfo) ? new MapInfo(params.mapInfo) : new MapInfo();
    }

    /**
     * 
     * @param {string} jsonStr 
     * @return {Sample}
     * 
     */
    static fromJson(jsonStr) {
        const obj = JSON.parse(jsonStr);
        const sample = new Sample(obj);
        return sample;
    }

    /**
     * 
     * @param {LayersPane} item 
     */
    addPane(pane) {
        this.panes.push(pane);
    }
    /**
     * 
     * @param {string} paneId 
     */
    removePane(paneId) { this.panes = this.panes.filter(pane => pane.paneId == paneId) }
}

class MapInfo {
    constructor(params) {
        if (params === undefined) { params = {} }
        this.viewCenter = (params.viewCenter) ? params.viewCenter : [0, 0];
        this.zoomLevel = (params.zoomLevel) ? params.zoomLevel : 2;
    }

    getView() {
        return new View({
            projection: 'EPSG:4326',
            center: this.viewCenter,
            zoom: this.zoomLevel,
        });
    }
    setFromView(view) {
        this.viewCenter = view.getCenter();
        this.zoomLevel = view.getZoom();
    }
}
class LayersPane {
    constructor(params) {
        this.paneId = (params.paneId) ? params.paneId : uid();
        this.name = params.name;
        this.description = params.description ? params.description : '';
        this.checkBoxList = new CheckBoxList(params.checkBoxList);
        this.icon = (params.icon) ? params.icon : '<i class="fa fa-map-o"></i>';
    }

    static fromJson(jsonStr) {
        const obj = JSON.parse(jsonStr);
        const pane = new LayersPane(obj);
        return pane;
    }

    definePane(sidePanel) {

        const pane = sidePanel.definePane(this);

        const div = document.createElement('div');
        div.className = 'panel_div';
        if (this.name.length > 0) {
            const h4 = document.createElement('h4');
            h4.innerHTML = this.name;
            div.appendChild(h4);
        }
        if (this.description.length > 0) {
            const p = document.createElement('p');
            p.innerHTML = this.description;
            div.appendChild(p);
        }
        div.appendChild(this.checkBoxList.createElements());

        pane.addWidgetElement(div);
    }
}

class CheckBoxList {
    constructor(params) {
        if (params === undefined) { params = {}; }
        this.name = (params.name) ? params.name : '';
        this.items = [];
        if (params.items !== undefined) {
            params.items.forEach(item => {
                this.addItem(CheckBoxItemFactory.GetItem(item));
            });
        }
    }

    static fromJson(jsonStr) {
        const obj = JSON.parse(jsonStr);
        const cbList = new CheckBoxList(obj);
        return cbList;

    }
    /**
     * 
     * @param {CheckBoxItem} item 
     */
    addItem(item) {
        this.items.push(item);
    }
    /**
     * 
     * @param {string} itemId 
     */
    removItem(itemId) { this.items = this.items.filter(item => item.cbId == itemId) }

    /**
     * 
     * @returns {HTMLDivElement} div
     */
    createElements() {
        const div = document.createElement('div');
        if (this.name.length > 0) {
            const h4 = document.createElement('h4');
            h4.innerHTML = this.name;
            div.appendChild(h4);
        }
        const ul = document.createElement('ul');
        ul.className = 'checkbox_ul';
        this.items.forEach(item => ul.appendChild(item.createElements()));
        div.appendChild(ul);
        return div;
    }

}

export { Sample, LayersPane, CheckBoxItemFactory, CheckBoxItem, CheckBoxList, 
    CheckBoxItemElevationImageLayer, CheckBoxItemRadarImageLayer, CheckBoxItemShaderImageLayer, 
    CheckBoxDiffImageLayer, CheckBoxItemGeoJsonLayer, MapInfo,
    CheckBoxItemBingMaps}